<template>
    <div style="margin-left: 75px;" v-resize = "onResize">
        <c-app-bar
            :title         = "'IMPORT - ' + title"
            :categories    = "[]"
            :enable-search = "false"
        >
            <template v-slot:search>
                <v-spacer />
            </template>
        </c-app-bar>

        <div
            class  = "lm-border"
            style  = "margin-right: 75px;"
            :style = "'height:' + (size.y- 10) + 'px'"
            @dragover.prevent
            @drop.prevent
        >
            <div class="ml-4 mt-3" style="width: 300px" v-if="!importData">
                <c-customer-select
                    v-model="customer"
                    label="Kunde"
                    :hide-details = "true"
                />
            </div>
            <div
                v-if       = "!importData && customer"
                @drop      = "onDrop"
                @dragleave = "fileDragOut"
                @dragover  = "fileDragIn"
                class      = "v-flex w-100 dropzone"
                :class     = "drag ? 'drop-allowed' : ''"
                @dragover.prevent
                @drop.prevent
            >
                <div class="drop-zone-icon">
                    <div style="text-align: center;">
                        <v-icon class="primary--text" size="70">mdi-cloud-upload</v-icon>
                    </div>
                    <div class="primary--text drop-zone-label">
                        {{ $t("importer.drophere") }}
                    </div>
                </div>
            </div>

            <div class="w-100 h-100" v-if="importData">
                <div class="pa-3 h-100" :key="refresh">
                    <div class="mt-0 pa-3 pt-0 v-flex">
                        <div>
                            <v-text-field
                                v-model     = "search"
                                append-icon = "mdi-magnify"
                                :label      = "$t('importer.search')"
                                style       = "font-size: 15px;"
                                @input      = "onSearch"
                                single-line
                                clearable
                                hide-details
                                dense
                            />
                        </div>
                        <v-btn
                            class="dialog-button ml-3"
                            color="primary"
                            :disabled = "!importData || (importData && importData.errors > 0)"
                            @click="onImport"
                        >
                            {{ $t("importer.doimport") }}
                        </v-btn>

                        <v-btn
                            class="dialog-button ml-3"
                            color="primary"
                            @click="onReset"
                        >
                            {{ $t("importer.newimport") }}
                        </v-btn>
                        <div v-if="customer" class="primary--text" style="text-align: center; flex-grow: 1 !important; font-size: 20px; font-weight: 600; padding-top: 0">
                            {{ customer.name }}
                        </div>

                        <v-btn
                            class="dialog-button ml-3"
                            color="primary"
                            @click="onErrors"
                            style="width: 185px;"
                        >
                            {{ filter.errors ? $t("importer.filter.errors.on") : $t("importer.filter.errors.off") }}
                        </v-btn>
                    </div>
                    <v-divider class="mb-3" />
                        <c-side-button
                            v-if    = "!importData.oneRowPerUnit"
                            v-model ="inout"
                            :left   = "true"
                            :title  = "inout ? $t('importer.output.title') : $t('importer.input.title')"
                            class   = "inout-button"
                        />
                        <p-import-input
                            v-if     = "inout"
                            :size    = "size"
                            :columns = "importData.inputColumns"
                            :rows    = "importData.inputRows"
                            :filter  = "filter"
                        />
                        <p-import-output
                            v-if    = "!inout && !importData.oneRowPerUnit"
                            :data   = "importData.output"
                            :size   = "size"
                            :filter = "filter"
                        />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import PImportInput from "@/modules/msd/importer/components/private/PImportInput.vue";
import PImportOutput from "@/modules/msd/importer/components/private/PImportOutput.vue";
import CAppBar from "@/modules/core/components/app/CAppBar.vue";
import Core from "@/modules/core/service/Core";
import Importer from "@/modules/msd/importer/service/Importer";
import CSideButton from "@/modules/core/components/utils/CSideButton.vue";
import CCustomerSelect from "@/modules/msd/company/customer/components/controlls/CCustomerSelect.vue";

export default {
    name: "MImportHome",

    components: {
        CCustomerSelect,
        CSideButton,
        CAppBar,
        PImportOutput,
        PImportInput,
    },

    data: () => ({
        customer: null,
        drag: false,
        importData: null,
        refresh   : 0,
        search    : null,
        title     : null,
        group     : null,
        definition: null,
        inout     : true,
        size      : {
            x: 0,
            y: 0
        },
        filter: {
            errors: false,
        }
    }),

    computed: {
        params () {
            return this.$route.params;
        },

        isUnitImport () {
            return this.params.id === "200";
        }
    },

    mounted () {
        this.initialize();
    },

    watch: {
        params () {
            this.initialize();
        }
    },

    methods: {
        initialize () {
            this.onResize();
            this.$store.getters.msd.importDefinitionGroups.forEach(group => {
                group.importDefinitions.forEach(definition => {
                    if (definition.id === parseInt(this.params.id)) {
                        this.definition = definition;
                        this.group      = group;
                    }
                })
            })


            this.importData = null;
            if (!this.params || !this.definition) {
                return;
            }

            this.title = this.group.name + " - " + this.definition.name;
        },

        onErrors () {
            this.filter.errors = !this.filter.errors;
        },

        onResize () {
            this.size.x = window.innerWidth - 15;
            this.size.y = window.innerHeight-60
        },

        onSearch (search) {
            this.search = search;
        },

        onDrop(e) {
            this.drag = false;
            let droppedFiles = e.dataTransfer.files;
            if(!droppedFiles) {
                return;
            }

            Core.loading(this, true);
            Array.from(droppedFiles).forEach (file => {
                Core.transfer.uploadReturnsJson("/api/import/upload/{0}?import={1}".replace("{0}", this.customer.id).replace("{1}", this.params.id), file, data => {
                    console.log("importData", data)
                    this.importData = data;
                    Core.loading(this, false);
                }, () => {
                    Core.loading(this, false);
                    Core.message.error(this, "Upload failed");

                });
            })
        },

        onImport () {
            Core.loading(this, true);
            Importer.import(this.customer.id, this.importData.output).then (() => {
                Core.loading(this, false);
                this.importData = null;
                Core.message.hint(this, this.$t("importer.process.success"))
            }).catch(() => {
                Core.loading(this, false);
                Core.message.error(this, this.$t("importer.process.error"))
            });
        },

        onReset () {
            this.clear();
        },

        clear () {
            this.importData = null;
        },

        fileDragIn(){
            this.drag = true;
        },

        fileDragOut() {
            this.drag = false;
        },
    }
}
</script>

<style scoped>

:deep(.v-window__container) {
    height: 100%;
}

.inout-button {
    width: 26px;
    left: 50px;
    top: 214px;
    height: 165px;
}

:deep(.tool-button) {
    border-radius: 5px;
}

.dropzone {
    width: 350px;
    height: 170px;
    border-radius: 4px;
    margin: 200px auto auto;
}

.drop-zone-icon {
    width: 100%;
    margin-top: 30px;
}

.drop-zone-label {
    font-size: 16px;
    text-align: center;
}

</style>